var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-body h-100 d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"mdi mdi-cursor-pointer mdi-48px text-muted"}),_c('h5',[_vm._v(_vm._s(_vm.$t('please-choose-chat-to-display')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }